export default __webpack_public_path__ + "alberta-shoppingcart-square.921b204cc89ce28bfd98.svg";